import BaseApi from './BaseApi';

type ImageDetailsBase<T> = {
  type: T;
  channelId: string;
};
export type ImageDetailsPut = ImageDetailsBase<'put'> & {
  files: File[];
};
export type ImageDetailsDelete = ImageDetailsBase<'delete'> & {
  messageId: string;
};

export type ImageDetails = ImageDetailsPut | ImageDetailsDelete;

/**
 * 画像送信API。
 */
class PutChatImageApi extends BaseApi {
  async send(details: ImageDetails) {
    const formData = this.buildFormData(
      Object.entries(details).reduce(
        (data, [key, value]) =>
          key === 'files'
            ? {
                ...data,
                ...(value as ImageDetailsPut['files']).reduce(
                  (files, file, idx) => ({
                    ...files,
                    [`fileData${idx + 1}`]: new File(
                      [file],
                      encodeURIComponent(file.name)
                    )
                  }),
                  {}
                )
              }
            : { ...data },
        {}
      )
    );
    return await this.execute(
      `putChatImageApi?${Object.entries(details)
        .filter(([key]) => key !== 'files')
        .map((entry) => entry.join('='))
        .join('&')}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        body: formData
      },
      true
    ).then(({ status }) => status === 1);
  }
}

export default PutChatImageApi;
